
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma-related types and utilities in a browser. 
 * Use it to get access to models, enums, and input types.
 * 
 * This file does not contain a `PrismaClient` class, nor several other helpers that are intended as server-side only.
 * See `client.ts` for the standard, server-side entry point.
 *
 * 🟢 You can import this file directly.
 */

import * as Prisma from './internal/prismaNamespaceBrowser'
export { Prisma }
export * as $Enums from './enums'
export * from './enums';
/**
 * Model User
 * 
 */
export type User = Prisma.UserModel
/**
 * Model Profile
 * 
 */
export type Profile = Prisma.ProfileModel
/**
 * Model Affiliate
 * 
 */
export type Affiliate = Prisma.AffiliateModel
/**
 * Model Course
 * 
 */
export type Course = Prisma.CourseModel
/**
 * Model Section
 * 
 */
export type Section = Prisma.SectionModel
/**
 * Model Chapter
 * 
 */
export type Chapter = Prisma.ChapterModel
/**
 * Model Blog
 * 
 */
export type Blog = Prisma.BlogModel
/**
 * Model Category
 * 
 */
export type Category = Prisma.CategoryModel
/**
 * Model Offering
 * 
 */
export type Offering = Prisma.OfferingModel
/**
 * Model StaticContent
 * 
 */
export type StaticContent = Prisma.StaticContentModel
/**
 * Model Image
 * 
 */
export type Image = Prisma.ImageModel
/**
 * Model Video
 * 
 */
export type Video = Prisma.VideoModel
/**
 * Model ChapterView
 * 
 */
export type ChapterView = Prisma.ChapterViewModel
/**
 * Model ChapterShare
 * 
 */
export type ChapterShare = Prisma.ChapterShareModel
/**
 * Model ChapterCompletion
 * 
 */
export type ChapterCompletion = Prisma.ChapterCompletionModel
/**
 * Model BlogShare
 * 
 */
export type BlogShare = Prisma.BlogShareModel
/**
 * Model CourseReview
 * 
 */
export type CourseReview = Prisma.CourseReviewModel
/**
 * Model ChapterLike
 * 
 */
export type ChapterLike = Prisma.ChapterLikeModel
/**
 * Model BlogLike
 * 
 */
export type BlogLike = Prisma.BlogLikeModel
/**
 * Model Comment
 * 
 */
export type Comment = Prisma.CommentModel
/**
 * Model CommentReaction
 * 
 */
export type CommentReaction = Prisma.CommentReactionModel
/**
 * Model Feedback
 * 
 */
export type Feedback = Prisma.FeedbackModel
/**
 * Model MockReview
 * 
 */
export type MockReview = Prisma.MockReviewModel
/**
 * Model SocialTestimonialScreenshot
 * 
 */
export type SocialTestimonialScreenshot = Prisma.SocialTestimonialScreenshotModel
/**
 * Model UpworkTestimonialScreenshot
 * 
 */
export type UpworkTestimonialScreenshot = Prisma.UpworkTestimonialScreenshotModel
/**
 * Model UpworkStatScreenshot
 * 
 */
export type UpworkStatScreenshot = Prisma.UpworkStatScreenshotModel
/**
 * Model Payment
 * 
 */
export type Payment = Prisma.PaymentModel
/**
 * Model Enrollment
 * 
 */
export type Enrollment = Prisma.EnrollmentModel
/**
 * Model Referral
 * 
 */
export type Referral = Prisma.ReferralModel
/**
 * Model Notification
 * 
 */
export type Notification = Prisma.NotificationModel
/**
 * Model UserNotification
 * 
 */
export type UserNotification = Prisma.UserNotificationModel
/**
 * Model NewsletterSubscription
 * 
 */
export type NewsletterSubscription = Prisma.NewsletterSubscriptionModel
